import { UserProfile } from "src/types/user";

export const CLIGHT_GROUP_ID = 4;

export function isCLightUser(userProfile: UserProfile | null) {
    return userProfile?.group_id === CLIGHT_GROUP_ID;
}

